import { combinePlugins } from "src/engine/helpers"
import { compose, withPropsOnChange, defaultProps, lifecycle } from "recompact"
import { reduxForm, clearSubmitErrors, stopSubmit } from "redux-form"
import isFunction from "lodash/isFunction"
import submission from "./submission"

/**
 * @deprecated
 *
 * Avoid using it in new components
 */
export default enhancer => {
  const enhancers = [
    withPropsOnChange(
      (nextProps, props) =>
        nextProps.to !== props.to ||
        nextProps[nextProps.to].data !== props[props.to].data ||
        nextProps[nextProps.to].id !== props[props.to].id ||
        nextProps[nextProps.to].api !== props[props.to].api,
      props => {
        const { to } = props
        const {
          [to]: {
            data,
            id,
            api: { save },
          },
          form,
          onSubmit,
          enableReinitialize = true,
        } = props

        const formName = form || `${to}-${id || `new`}`
        const onSubmitHandler =
          onSubmit ||
          ((data, dispatch, { pristine }) => {
            // Protection from empty fields saving
            if (!pristine) {
              return save(data)
            }
            return false
          })

        return {
          form: formName,
          enableReinitialize,
          initialValues: data,
          onSubmit: onSubmitHandler,
        }
      },
    ),
  ]
  if (isFunction(enhancer)) {
    enhancers.push(enhancer)
  }
  enhancers.push(
    defaultProps({
      /* O! M! G! 18 hours I spent to find up the causality and solution.
     * Listen to me, kids, if onSubmit returns rejectable Promise YOU MUST
     * specify onSubmitFail, otherwise you'll get unhandled Promise
     * rejection
     *
     * Now, I tell you all causal relationship. When your onSubmit
     * returns a promise, redux-form starts listening for its rejection
     * and it's OK. But when Promise will throw an error for real,
     * redux-form re-throws error in free flight. As a result of this
     * immoral act, an unhandled rejection event is triggered.
     *
     * Here are problematic chunks in redux-form lib:
     *
     * ```
     * return promise.then(_this.submitCompleted, _this.submitFailed);
     * ```
     *
     * ```
     * _this.submitFailed = function (error) {
          delete _this.submitPromise;
          throw error;
        }
     * ```
     * */
      onSubmitFail() {
        // Do nothing, just fix the error with unhandledRejection
      },

      /* Erase validation errors on form change */
      onChange: (values, dispatch, props) => {
        if (props.error) {
          /* Omg. It doesn't work. Redux-form disappointed me. */
          dispatch(stopSubmit(props.form))
          dispatch(clearSubmitErrors(props.form))
        }
      },
    }),
  )
  enhancers.push(reduxForm())
  enhancers.push(
    /* Feedback to upper components */
    lifecycle({
      // eslint-disable-next-line camelcase
      UNSAFE_componentWillReceiveProps(nextProps) {
        /* We should tell to uppers that pristine has changed */
        if (nextProps.pristine !== this.props.pristine) {
          if (nextProps.onPristineChange) {
            nextProps.onPristineChange(nextProps.pristine)
          }

          if (nextProps.pristine) {
            this.props.workspace.removeLabel(`dirty`)
          } else {
            this.props.workspace.addLabel(`dirty`)
          }
        }

        /* We should tell to uppers that invalid has changed */
        if (nextProps.invalid !== this.props.invalid) {
          /* We should not tell that form is invalid, if there
           * is an error exists. Because error is provided
           * by server validation and user must have an ability
           * to send form again to fix error */
          if (nextProps.invalid && !nextProps.error) {
            this.props.workspace.addLabel(`invalid`)
          } else {
            this.props.workspace.removeLabel(`invalid`)
          }
        }
      },
    }),
  )

  return combinePlugins(submission(), {
    after: compose(...enhancers),
  })
}
